import clsx, { type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Class composition where the last utility wins.
 *
 * `clsx` alone concatenates, so a `w-auto` passed into a control that already
 * carries `w-full` produces `w-full w-auto` and CSS source order — not the
 * caller — decides. That shipped a job card whose stage rail was crushed to
 * zero width, and neither the typechecker nor a jsdom test can see it.
 *
 * Every component that accepts a `className` must compose it through here.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
